import api from 'app/shared/utils/api';
import promise from 'promise';

import DispatchConstants from 'app/shared/constants/DispatchConstants';
import CoreProductInvoice from 'app/shared/model/CoreProductInvoice';

import Graphs from 'app/shared/model/Graphs';
import PropertiesReport from 'app/shared/model/PropertiesReport';
import BoostAdReport from 'app/shared/model/BoostAdReport';
import BoostAdPreviews from 'app/shared/model/BoostAdPreviews';
import OverviewFilter from 'app/shared/model/OverviewFilter';

import adproductsUtils from 'app/shared/utils/adproductsUtils';

const AnalyticsActions = {
    comscore() {
        return dispatch => dispatch(api.users.analytics.comscore())
            .catch(err => console.error('could not ping comscore', err));
    },
    getCoreProductInvoice(params = {}) {
        return dispatch => dispatch(api.users.analytics.getCoreProductInvoice(params))
            .then((result) => {
                if (result.success) {
                    const coreProductInvoice = CoreProductInvoice(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_SUCCESS,
                        payload: coreProductInvoice,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_FAIL,
                payload: err,
            }));
    },
    getPropertiesReport(params = {}) {
        return dispatch => dispatch(api.users.analytics.getProperties(params))
            .then((result) => {
                if (result.success) {
                    const propertiesReport = PropertiesReport(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_PROPERTIES_GET_SUCCESS,
                        payload: propertiesReport,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTICS_PROPERTIES_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTICS_PROPERTIES_GET_FAIL,
                payload: err,
            }));
    },
    getBoostAdReport(params = {}) {
        return dispatch => dispatch(api.users.analytics.getBoostAdReport(params))
            .then((result) => {
                if (result.success) {
                    const boostAdReport = BoostAdReport(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_BOOST_AD_GET_SUCCESS,
                        payload: boostAdReport,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTICS_BOOST_AD_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTICS_BOOST_AD_GET_FAIL,
                payload: err,
            }));
    },
    getBoostAdPreviews(params = {}) {
        return dispatch => dispatch(api.users.analytics.getBoostAdPreviews(params))
            .then((result) => {
                if (result.success) {
                    const boostAdPreviews = BoostAdPreviews(result.response);
                    return boostAdPreviews;
                }
                return promise.reject(result.error);
            })
            .catch(err => promise.reject(err));
    },
    getMonthlyOverviewStats(filterParams = {}) {
        const ranges = adproductsUtils.getOneYearMonthRanges();
        const failType = DispatchConstants.ANALYTICS_OVERVIEW_INVOICES_GET_FAIL;
        return dispatch => Promise.all(ranges.map((range) => {
            const params = {
                year: range[0],
                month: range[1],
                ...filterParams,
            };
            return dispatch(api.users.analytics.overview.getMonthlyOverviewSummary(params))
                .then(response => response.response);
        })).then((stats) => {
            const graphs = {
                coreProduct: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.coreProductCost, 0),
                        months: stats.map(stat => ({
                            startDate: adproductsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.coreProductCost,
                        })),
                    },
                },
                rocketship: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.rocketshipCost, 0),
                        months: stats.map(stat => ({
                            startDate: adproductsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.rocketshipCost,
                        })),
                    },
                },
                singleFamilyLegacy: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.singleFamilyLegacy, 0),
                        months: stats.map(stat => ({
                            startDate: adproductsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.singleFamilyLegacy,
                        })),
                    },
                },
                boost: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.boostCost, 0),
                        months: stats.map(stat => ({
                            startDate: adproductsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.boostCost,
                        })),
                    },
                },
                leaseConnect: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.leaseConnectCost, 0),
                        months: stats.map(stat => ({
                            startDate: adproductsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.leaseConnectCost,
                        })),
                    },
                },
            };
            return Graphs(graphs);
        }).then(graphModel => dispatch({
            type: DispatchConstants.ANALYTICS_OVERVIEW_GET_SUCCESS,
            payload: graphModel,
        })).catch(err => dispatch({
            type: failType,
            payload: err,
        }));
    },
    getGraphs(graphsType = '', params = {}) {
        let endpoint;
        let failType;
        switch (graphsType) {
            default:
                endpoint = api.users.analytics.overview.getReviews;
                failType = DispatchConstants.ANALYTICS_OVERVIEW_REVIEWS_GET_FAIL;
                break;
        }
        return dispatch => dispatch(endpoint(params))
            .then((result) => {
                if (result.success) {
                    const graphs = Graphs(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_OVERVIEW_GET_SUCCESS,
                        payload: graphs,
                    });
                }
                return dispatch({
                    type: failType,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: failType,
                payload: err,
            }));
    },
    getOverviewFilter() {
        return dispatch => dispatch(api.users.analytics.overview.getFilter())
            .then((result) => {
                if (result.success) {
                    const listings = OverviewFilter(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_OVERVIEW_FILTER_GET_SUCCESS,
                        payload: listings,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTICS_OVERVIEW_FILTER_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTICS_OVERVIEW_FILTER_GET_FAIL,
                payload: err,
            }));
    },
};

export default AnalyticsActions;
